module.exports = __webpack_public_path__ + "static/media/Release.fe8cf11f.jpg";